import cx from 'classnames';
import { Coffee, Clock, ShieldCheck, Star } from 'lucide-react';
import Image from '@/common/Image';
import { appAssetsCdnUrl } from '~/constants/environment';
import styles from './WhyServiceWithUs.module.css';

const valueProps = [
  {
    heading: 'We’ll tell you what you need \u2014 and what you don’t.',
    compact:
      'Advisors recommend only what your vehicle actually needs \u2014 nothing extra.',
    Icon: ShieldCheck
  },
  {
    heading: 'Realistic timelines. Real-time updates.',
    compact:
      'Promise times we keep \u2014 and text updates when anything changes.',
    Icon: Clock
  },
  {
    heading: 'A service center that doesn’t feel like one.',
    compact:
      'Comfortable lounge, fast Wi-Fi, and a team that remembers your name.',
    Icon: Coffee
  }
];

export default function WhyServiceWithUs() {
  return (
    <section className="bg-canvas-muted px-lg py-4xl md:px-2xl md:py-[96px]">
      <div className="mx-auto grid max-w-[1272px] grid-cols-1 gap-4xl lg:grid-cols-[1.3fr_1fr] lg:items-start">
        <div>
          <div className="mb-lg text-text-primary t-label-xs tracking-widest">
            WHY PARK CITIES DRIVERS KEEP COMING BACK
          </div>
          <h2 className="mb-3xl max-w-[560px] text-text-strong t-heading-3xl md:mb-4xl md:t-heading-4xl">
            Good service shouldn’t feel like a sales pitch.
          </h2>

          <div className="flex flex-col gap-[20px]">
            {valueProps.map(prop => (
              <div
                key={prop.heading}
                className="grid grid-cols-[44px_1fr] items-start gap-lg"
              >
                <div className="flex size-[44px] items-center justify-center rounded-[10px] bg-background-primary-muted text-text-primary">
                  <prop.Icon size={20} />
                </div>
                <div>
                  <h3 className="mb-xs text-text-strong t-strong-lg">
                    {prop.heading}
                  </h3>
                  <p className="text-text-default t-body-md">{prop.compact}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="sticky top-6xl hidden flex-col gap-y-xl lg:flex">
          <Image
            src={`${appAssetsCdnUrl}/images/dealership/cdjr/pickup-dealer-desktop.jpg`}
            alt="Carvana CDJR of Park Cities dealership"
            width={640}
            height={400}
            className="aspect-[16/10] rounded-xl object-cover object-[22%_45%]"
          />

          <div className="rounded-2xl border border-border-subtle bg-canvas-default p-2xl">
            <div className="mb-lg flex gap-x-xs">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className="size-[18px] fill-[#FAB005] text-[#FAB005]"
                />
              ))}
            </div>
            <p className="mb-lg text-text-strong t-strong-md">
              “They told me my brakes had 8,000 more miles in them. Any other
              shop would have just swapped them. I’m not going anywhere else.”
            </p>
            <div className="flex items-center gap-x-lg border-t border-border-subtle pt-lg">
              <div
                className={cx(
                  'grid size-[36px] shrink-0 place-items-center rounded-full text-text-inverse',
                  styles.avatar
                )}
              >
                MR
              </div>
              <div>
                <div className="text-text-strong t-strong-xs">Marcus R.</div>
                <div className="text-text-default t-body-xs">
                  2022 Jeep Grand Cherokee · 3 service visits
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
